<template>
  <white-bg padding="0">
    <row margin="0px 0px 0px 0px" class="chat__top">
      <grid-item xs="12" xl="4" class="side">
        <search placeholder="Поиск" v-model="search"/>
      </grid-item>
      <grid-item xs="8" class="chat__row" v-if="!isMobile">
        <div class="client" v-if="currentUser">
          <div class="name">{{ currentUser.fullName }}</div>
          <button class="chat__top-add" v-if="!currentUser.isClient && !currentUser.isAdmin" @click="addClient()">Добавить в клиентов</button>
          <router-link v-if="currentUser.isClient && !currentUser.isAdmin" :to="{name: 'master.cabinet.calendar', params: {calendar: 'rents'}}" class="chat__top-write">
            Записать клиента
          </router-link>
        </div>
      </grid-item>
    </row>
    <row margin="0px">
      <grid-item xs="12" xl="4" class="side" v-if="isMessageShown">
        <div class="side__previews">
          <Messages :messages="dialogs" @conversation="onConversation" :search="search"/>
        </div>
      </grid-item>
      <grid-item xl="8" xs="12" v-if="!chat_chosen && !isMobile">
        <Chat_dont_chosed/>
      </grid-item>
      <grid-item xl="8" xs="12" v-else-if="chat_chosen && isDialogShown" style="display: flex">
        <div class="mobile__dialog">
          <div class="dialog__top" v-if="isMobile">
            <button class="top_btn backLink" @click="isDialog = false">
              <img src="../../../assets/images/icons/chevron-left-black.svg" alt="">
            </button>
            <span class="username" v-if="currentUser">{{ currentUser.fullName }}</span>
            <button class="top_btn showMore" @click="showMore = !showMore">
              <img src="../../../assets/images/icons/chevron-down-black.svg" alt="">
            </button>
          </div>
          <div class="dialog__under_top" v-if="showMore">
            <div class="client">
              <button class="chat__top-add" v-if="!currentUser.isClient" @click="addClient()">Добавить в клиентов</button>
              <router-link v-else :to="{name: 'master.cabinet.calendar', params: {calendar: 'rents'}}" class="chat__top-write">
                Записать клиента
              </router-link>
            </div>
          </div>
          <div class="chat__dialog" style="overflow: hidden">
            <transition name="fade-top" mode="out-in">
              <div class="chat__dialog-input" v-if="!loading">
                <Dialog :dialog="messages"/>
                <row class="input" style="align-self: flex-end" v-if="conversationId">
                  <chat-input placeholder="Напишите сообщение" v-on:send="addConversationMessage"/>
                </row>
              </div>
            </transition>
          </div>
        </div>
      </grid-item>
    </row>
  </white-bg>
</template>

<script>
import WhiteBg from '../../../components/ui/white-bg'
import Search from '../../../components/ui/inputs/custom-search'
import Row from '../../../components/grid/Row'
import GridItem from '../../../components/grid/GridItem'
import Messages from '../../../components/Messages'
import Dialog from '../../../components/Dialog'
import ChatInput from "../../../components/ui/inputs/chat-input";
import ChatMixin from "@/mixins/chat";
import Chat_dont_chosed from '@/components/ui/chat_dont_chosed'

window.Pusher = require('pusher-js');

export default {
  name: 'Chat',
  mixins: [ChatMixin],
  components: {Chat_dont_chosed, Dialog, WhiteBg, GridItem, Search, Row, Messages, ChatInput},
  data: () => ({
    loading: false,
    isMobile: false,
    isDialog: false,
    showMore: false,
    currentUser: null,
    search: '',
    chat_chosen: false
  }),
  computed: {
    isDialogShown() {
      if (!this.isMobile) return true
      return this.isDialog
    },
    isMessageShown() {
      if (!this.isMobile) return true
      return !this.isDialog
    },
  },
  mounted() {
    this.read();
    this.loadDialogues();
    this.isMobile = document.documentElement.clientWidth < 991;
  },
  methods: {
    addClient() {
      this.$api.master.client.add(this.currentUser.id).then(() => {
        this.$set(this.currentUser, 'isClient', true);
        this.$toast.success('Клиент успешно добавлен!');
      });
    },
    loadClient(id) {
      return this.$api.master.client.item(id);
    },
    onConversation({id, fullname, participant}) {
      this.setConversationId(id);
      this.isDialog = true;
      this.chat_chosen = true
      this.showMore = false;
      this.currentUser = null;
      this.loading = true;
      this.loadClient(participant.id)
        .then(({data}) => {
          this.currentUser = participant;
          this.$set(this.currentUser, 'isAdmin', participant.type === "admin");
          this.$set(this.currentUser, 'isClient', !!data.id);
          this.$set(this.currentUser, 'fullName', fullname);
        })
        .finally(() => this.loading = false)
    }
  }
}
</script>

<style scoped lang="scss">
h3 {
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #383838;
  left: auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.client {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  .name {
    font-size: 16px;
    font-weight: 600;
  }
}

.input {
  display: flex;
  justify-content: center;
  border-top: 1px solid #E5E5E5;
  padding: 15px 15px 0px 15px;
}

.side {
  border-right: 1px solid #E5E5E5;
  padding: 0 0;

  &__previews {
    height: 70vh;
  }
}

.whiteBg {
  padding: 0;
}

.chat {
  width: 100%;
  background-color: #fff;

  &__dialog {
    height: 100%;
    display: flex;
    align-items: flex-end;

    &-input {
      width: 100%;
      padding: 0 0 10px 0;
    }
  }

  &__row {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #E5E5E5;
    padding: 0 -15;

    &-title {
      font-weight: 600;
      font-size: 20px;
      line-height: 1.4;
      color: #383838;
    }

    &-add {
      width: initial;
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #B9765B;
      background-color: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      padding: 0 10px;

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        margin-right: 5px;

        background-image: url("../../../assets/images/icons/plus.svg");
        background-position: center center;
        background-size: contain;
      }
    }

    &-write {
      font-weight: 600;
      font-size: 16px;
      line-height: 1.4;
      color: #B9765B;
      background-color: transparent;
      border: none;
      cursor: pointer;
      display: flex;
      align-items: center;
      right: 20px;
      padding: 0 10px;

      &:before {
        content: '';
        width: 20px;
        height: 20px;
        margin-right: 5px;
        background-image: url("../../../assets/images/icons/calendar.svg");
        background-position: center center;
        background-size: contain;
      }
    }
  }

  &__more {
    button {
      margin: 0 auto;
      display: flex;
      align-items: center;
      border: none;
      background-color: transparent;
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: #B9765B;

      &:after {
        content: '';
        width: 20px;
        height: 20px;
        margin-left: 5px;
        background-image: url("../../../assets/images/icons/chevron-down.svg");
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
  }

}

.mobile__dialog {
  width: 100%;
}

.dialog__top {
  margin: 0 -15px;
  padding: 13px 15px;
  border-bottom: 1px solid #E5E5E5;
  display: flex;
  align-items: center;

  .top_btn {
    background-color: transparent;
    border: none;
    width: 20px;
    height: 20px;

    &.backLink {
      margin-right: 5px;
    }

    &.showMore {
      margin-left: auto;
    }
  }

  .username {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #383838;
  }
}

.chat__top-write {
  text-decoration: none !important;
}

@media screen and (max-width: 991px) {
  .chat__dialog {
    height: unset;
  }
  .client {
    justify-content: flex-start;
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 1px solid #E5E5E5;
    margin: 0 -15px;
    padding: 15px;

    .chat__top-add,
    .chat__top-write {
      text-decoration: none !important;
      padding: 0;
    }

    .chat__top-add {
      margin-bottom: 15px;
    }
  }
}
</style>
